import isTransientFetchError from '@/core/utils/is-transient-fetch-error';

function getCauseCode(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const { cause } = error as { cause?: unknown };
  if (!cause || typeof cause !== 'object') {
    return undefined;
  }

  const { code } = cause as { code?: unknown };
  return typeof code === 'string' ? code : undefined;
}

function logUniformFetchError(
  context: string,
  error: unknown,
  meta?: Record<string, string>,
): void {
  const transient = isTransientFetchError(error);
  const payload = {
    code: transient ? 'UNIFORM_FETCH_TRANSIENT' : 'UNIFORM_FETCH_FAILED',
    context,
    transient,
    message: error instanceof Error ? error.message : String(error),
    cause: getCauseCode(error),
    ...meta,
  };

  console.error(JSON.stringify(payload));
}

export default logUniformFetchError;
